// DBS document dropdown options — split into "primary ID" (Document 1)
// and "secondary supporting docs" (Documents 2 & 3).
export const DOCUMENT_1_OPTIONS = [
  "Passport",
  "Driving Licence",
  "Birth Certificate",
];

export const DOCUMENT_2_3_OPTIONS = [
  "Adoption Certificate (UK and Channel Islands)",
  "An entitlement document from government (UK /CHI)",
  "Bank/Building Society Statement (UK or EEA)",
  "Benefit Statement",
  "Biometric Residence Permit (UK)",
  "Cards with the PASS accreditation logo (UK/CHI)",
  "Council Tax Statement (UK & Channel Islands)",
  "Credit Card Statement (UK or EEA)",
  "Current valid Passport",
  "EU National ID Card",
  "Financial Statement",
  "Fire Arms Licence (UK and Channel Islands)",
  "HM Forces ID Card (UK)",
  "Letter from Head Teacher or College Principal",
  "Mortgage Statement (UK or EEA)",
  "P45/P60 Statement (UK & Channel Islands)",
  "Paper Driving Licence /UK /Mann /CHI /EU",
  "Photo Driving Licence (All countries except Group 1 )",
  "Photo Driving Licence /UK /Mann /CHI /EU",
  "UK Bank/Building Society AOC Letter",
  "UK Birth Certificate /CHI- issued after birth",
  "UK Birth Certificate /CHI- issued at birth",
  "UK Marriage/Civil Partnership Certificate /CHI",
  "Utility Bill (UK) - Electricity",
  "Utility Bill (UK) - Gas",
  "Utility Bill (UK) - Phone (landline only)",
  "Utility Bill (UK) - Water",
  "Work Permit/Visa (UK) (UK Residence Permit)",
];
